<template>
  <v-dialog
    :value="show"
    fullscreen
    transition="dialog-bottom-transition"
    @input="onDialogUpdate"
  >
    <v-card tile>
      <v-toolbar flat dark color="teal">
        <v-btn icon dark @click.native="close">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>Settings</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn dark text @click.native="save">Save</v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text class="pt-4">
        <editor
          v-if="renderEditor"
          toolbar="undo redo | bold italic strikethrough | alignleft aligncenter alignright alignjustify | numlist bullist outdent indent"
          :plugins="[]"
          :init="editorOtherOptions"
          v-model="localContent"
          @onDirty="dirty = true"
        ></editor>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import Editor from '@tinymce/tinymce-vue'

import 'tinymce/tinymce'
import 'tinymce/themes/silver/theme'

export default {
  name: 'rich-text-editor-modal',

  components: {
    Editor,
  },

  model: {
    prop: 'show',
    event: 'input'
  },

  props: {
    show: Boolean,

    content: String
  },

  data () {
    return {
      editor: null,

      editorOtherOptions: {
        menubar: false,
        height: window.innerHeight * 0.6,
        skin_url: '/static/tinymce/skins/ui/oxide',
        content_css: '/static/tinymce/skins/content/default/content.min.css',
        setup: (editor) => this.onEditorInit(editor)
      },

      localContent: '',

      dirty: false,
      renderEditor: false,
    }
  },

  watch: {
    show (show) {
      if (show) {
        if (this.renderEditor) {
          this.editor.resetContent()
          this.copyPropContentToLocal()
        } else {
          setTimeout(() => {
            this.renderEditor = true
          }, 100)
        }
      } else {
        this.localContent = ''
      }
    }
  },

  methods: {
    onEditorInit (editor) {
      this.editor = editor

      this.copyPropContentToLocal()
    },

    onDialogUpdate (show) {
      this.$emit('input', show)
    },

    close () {
      this.$emit('input', false)
      this.dirty = false
    },

    save () {
      if (this.dirty) {
        this.$emit('update:content', this.localContent)
      }
      this.close()
    },

    copyPropContentToLocal () {
      this.localContent = !this.content ? '' : this.content
    }
  }
}
</script>

<style lang="stylus" scoped>

</style>



// WEBPACK FOOTER //
// src/components/Common/RichTextEditorModal.vue